import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { sendTestMessage } from '../../api/whatsapp/portalWhatsAppApi';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Input,
  Textarea,
  Button,
  Alert,
} from '../../components/ui';

const TestMessageCard = () => {
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [statusText, setStatusText] = useState(null);

  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatusText(null);
    try {
      const res = await sendTestMessage(phone, message);
      setStatusText({ type: 'success', msg: res.message });
      setMessage('');
    } catch (err) {
      setStatusText({
        type: 'error',
        msg: err.response?.data?.message || 'Failed to dispatch message.', }); } finally { setLoading(false); } }; return ( <Card> <CardHeader className="border-b bg-neutral-50/50 py-3.5"> <CardTitle className="text-base font-semibold text-neutral-900 dark:text-neutral-100"> Dispatch Manual Test Message </CardTitle> </CardHeader> <CardContent className="p-4 space-y-4"> {statusText && ( <Alert variant={statusText.type ==='success' ? 'success' : 'danger'}
            title={statusText.type === 'success' ? 'Message Sent' : 'Dispatch Failed'}
          >
            {statusText.msg}
          </Alert>
        )}

        <form onSubmit={handleSend} className="space-y-4">
          <Input
            label="Recipient Phone"
            type="text"
            placeholder="+919876543210"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />

          <Textarea
            label="Message Text"
            rows={3}
            placeholder="Hello! Test message from Phase 1 Baileys engine."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <Button
            type="submit"
            variant="primary"
            fullWidth
            isLoading={loading}
            leftIcon={<Send className="h-4 w-4" />}
          >
            Send Test Message
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default TestMessageCard;